/**
 * Form rules shared by the auth screens (FR2, FR3) and the create chat pop-ups (FR60).
 */

import { i18n } from '../localization/i18n';

export const DEFAULT_COUNTRY_CODE = 'CD';
export const DEFAULT_DIAL_CODE = '+243';

export const PHONE_MAX_LENGTH = 20;

// Common rule 13, plus the 10 MB limit of E5.
export const AVATAR_MAX_BYTES = 10 * 1024 * 1024;
export const AVATAR_ALLOWED_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/svg+xml',
    'image/heic',
    'image/heif',
    'image/avif',
];

/**
 * E1 for a mandatory field left blank.
 *
 * @param {string} field Translated field name.
 * @returns {string} "[Field name] is required".
 */
export const requiredFieldError = field => i18n.t('register.ERR_REQUIRED', { field });

/**
 * Strip everything but digits, then cap at the field limit.
 *
 * @param {string} value Raw input value.
 * @returns {string} Digits only, at most PHONE_MAX_LENGTH of them.
 */
export const sanitisePhone = (value = '') => value.replace(/\D/g, '').slice(0, PHONE_MAX_LENGTH);

/**
 * Check an avatar or logo file before it is used: E7 for the format, E5 for the size.
 *
 * @param {File} file File chosen by the user.
 * @returns {string} Error message, or an empty string when the file is usable.
 */
export const validateAvatar = file => {
    if (!file) return '';
    if (!AVATAR_ALLOWED_TYPES.includes(file.type)) return i18n.t('register.ERR_UNSUPPORTED_FORMAT');
    if (file.size > AVATAR_MAX_BYTES) return i18n.t('register.ERR_FILE_TOO_LARGE');
    return '';
};
